import { TransactionFlag } from '@shared/transactions-types';

import { hasFlag } from './hasFlag';
import type { TransactionPredicate } from './types';

export const isVisible: TransactionPredicate = hasFlag(TransactionFlag.IS_VISIBLE);
